/**
 * Português (pt) — a partial of `content/en.ts`.
 *
 * Anything omitted renders in English, on purpose. Only the interface strings
 * are translated so far: the marketing copy in the base file is placeholder,
 * and translating placeholder copy is work that has to be thrown away twice.
 */
import type { Translation } from '@/i18n/dictionary'

export const pt: Translation = {
  nav: {
    languageLabel: 'Idioma',
    skipToContent: 'Ir para o conteúdo',
    cta: { label: 'Fale com a gente' },
  },
  contactBand: {
    heading: 'Vamos conversar!',
    cta: { label: 'Fale com a gente' },
    photoAlt: 'Cactos coloridos emoldurados por um ribbon degradê da Digitopia',
  },
  footer: {
    rights: 'Todos os direitos reservados.',
  },
  preview: {
    badge: 'Pré-visualização',
    notice: 'Esta é uma pré-visualização não aprovada do digitopia.ai. O conteúdo é um rascunho.',
  },
  ui: {
    previous: 'Anterior',
    next: 'Próximo',
  },
}
